import { createSlice } from "@reduxjs/toolkit";
import Logo from "../../assets/logo.png";

const initialState = {
  logo: Logo,
};

export const logoSlice = createSlice({
  name: "logo",
  initialState,
  reducers: {
    setLogo: (state, action) => {
      state.logo = action.payload;
    },
  },
});

export const { setLogo } = logoSlice.actions;
export default logoSlice.reducer;
